import React from "react";
import { ThemePalette } from "../../../../theme/_Types";
import { FlexRow } from "../../03-base/Flex/Row";
import { FillUp } from "../../04-helpers/FillUp";
export var Page = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(FlexRow, { isScrollable: true },
        React.createElement(FillUp, { theme: { palette: ThemePalette.CONTRAST_SECONDARY } }, props.children)))); };
